import React from "react";
import Login from "../components/login";
import App from "../App";

const routes = {
    "/": () => <App/>,
    "/login": () => <Login/>
    //"/login": () => <App/>
}

export default routes
